import { useEffect } from "react";
import { Framedview_User_Agent, GATSBY_MOBILE_APP } from "../@types/Constants";
import { checkWebFramed } from "../redux/slices/WebFramed/WebFramed";
import { useAppDispatch, useAppSelector } from "./index";

export const useWebFramed = (): boolean => {
  const dispatch = useAppDispatch();
  const isWebFramed = useAppSelector((state) => state.isWebFramed);
  useEffect(() => {
    if (!isWebFramed && GATSBY_MOBILE_APP) {
      const framedView =
        typeof window !== "undefined" &&
        navigator.userAgent.indexOf(Framedview_User_Agent) > -1
          ? true
          : false;
      if (isWebFramed !== framedView) {
        dispatch(checkWebFramed(framedView));
      }
    }
  }, []);
  return isWebFramed && (GATSBY_MOBILE_APP as boolean);
};
